import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const EntityContext = createContext(null);

const ENTITY_CONFIG = {
  all: { label: 'All Entities', shortLabel: 'All', color: 'bg-gray-600', textColor: 'text-gray-700' },
  sam_rumah: { label: 'SAM Rumah', shortLabel: 'SR', color: 'bg-emerald-600', textColor: 'text-emerald-700' },
  sp_sam: { label: 'SP SAM Property', shortLabel: 'SP', color: 'bg-blue-600', textColor: 'text-blue-700' },
};

export const EntityProvider = ({ children }) => {
  const [currentEntity, setCurrentEntity] = useState(() => {
    const stored = localStorage.getItem('selectedEntity');
    if (stored && ENTITY_CONFIG[stored]) return stored;
    // Detect from hostname
    const host = window.location.hostname;
    if (host.includes('spsam') || host.includes('sp-sam')) return 'sp_sam';
    if (host.includes('samrumah') || host.includes('sam-rumah')) return 'sam_rumah';
    return 'all';
  });

  useEffect(() => {
    localStorage.setItem('selectedEntity', currentEntity);
  }, [currentEntity]);

  const switchEntity = useCallback((entity) => {
    if (ENTITY_CONFIG[entity]) setCurrentEntity(entity);
  }, []);

  const entityParam = currentEntity === 'all' ? '' : `entity=${currentEntity}`;
  const entityQuery = currentEntity === 'all' ? {} : { entity: currentEntity };

  return (
    <EntityContext.Provider value={{ currentEntity, switchEntity, entityParam, entityQuery, config: ENTITY_CONFIG }}>
      {children}
    </EntityContext.Provider>
  );
};

export const useEntity = () => {
  const context = useContext(EntityContext);
  if (!context) throw new Error('useEntity must be used within EntityProvider');
  return context;
};

export { ENTITY_CONFIG };
